module.exports = __webpack_public_path__ + "static/img/77117B_1_R_20201123_LC.bdfe667.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77117B_1_R_20201123_LC.png
// module id = pLbc
// module chunks = 0